import React from "react";
import Img from "react-image";
import Classnames from "classnames";
import moment from "moment";
import SVG from "react-inlinesvg";
import _ from "lodash";
import { fadeIn, fadeOut } from "react-animations";
import Radium, { StyleRoot } from "radium";
//AriveeIcon
import srcEnfantAbsent from "./styles/img/enfant-absent.svg";
import srcEnfantAttendu from "./styles/img/enfant-attendu.svg";
import srcEnfantParti from "./styles/img/enfant-parti.svg";
import srcEnfantSortie from "./styles/img/icon-enfant-sortie.svg";
import srcEnfantPresent from "./styles/img/enfant-present.svg";
import srcEnfantArrive from "./styles/img/icon-arrivee.svg";
//Activite et Sante par Défaut
import srcActivite from "./styles/img/icon-activite.svg";
//santeIcon
import srcIconFievre from "./styles/img/icon-fievre.svg";
import srcIconVomi from "./styles/img/icon-vomi.svg";
import srcIconToux from "./styles/img/icon-toux.svg";
import srcIconblessure from "./styles/img/icon-blessure.svg";
import srcIconBoutons from "./styles/img/icon-boutons.svg";
//  ActiviteIcon
import srcIconPateAModule from "./styles/img/icon-pate-a-modeler.svg";
import srcIconPienture from "./styles/img/icon-peinture.svg";
import srcIconDanse from "./styles/img/icon-danse.svg";
import srcIconSortie from "./styles/img/icon-sortie.svg";
import srcIconPiscine from "./styles/img/icon-piscine.svg";
import srcIconLecture from "./styles/img/icon-lecture.svg";
import srcIconActiviteManuelle from "./styles/img/icon-activites-manuelles.svg";
import srcIconAutre from "./styles/img/icon-autre.svg";

//PetiCoin
import srcIconPetitCoin from "./styles/img/icon-petitcoin.svg";

//Sieste
import srcIconSieste from "./styles/img/icon-sieste.svg";
//Repas
import srcIconRepas from "./styles/img/icon-repas.svg";
import srcIconBiberon from "./styles/img/icon-biberon.svg";
//histo medicale
import srcIconHistoriqueMedical from "./styles/img/icon-historique-medical.svg";

export const SVGIcon = (props) => getPath(props);

const getPath = (props) => {
  const { width, style, className, height, viewBox, name } = props;
  switch (name) {
    case "PRESENT":
      return (
        <svg
          width="26px"
          height="26px"
          viewBox="0 0 26 26"
          fill="#004CC5"
          className={className}
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
        >
          <path
            {...props}
            d="M0.3,14C0.1,13.8,0,13.5,0,13.3s0.1-0.5,0.3-0.7l1.4-1.4c0.4-0.4,1-0.4,1.4,0l0.1,0.1l5.5,5.9
          c0.2,0.2,0.5,0.2,0.7,0L22.8,3.3h0.1l0,0c0.4-0.4,1-0.4,1.4,0l1.4,1.4c0.4,0.4,0.4,1,0,1.4l0,0l-16,16.6C9.5,22.9,9.3,23,9,23
          s-0.5-0.1-0.7-0.3l-7.8-8.4C0.5,14.3,0.3,14,0.3,14z"
          />
        </svg>
      );
    case "ATTENDU":
      return (
        <svg
          version="1.1"
          id="Capa_1"
          xmlns="http://www.w3.org/2000/svg"
          xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          width="26px"
          height="26px"
          fill="#999999"
          viewBox="0 0 47 47"
          space="preserve"
        >
          <path
            d="M22.4,22.4c0,0.6,0.5,1.1,1.1,1.1s1.1-0.5,1.1-1.1c0-1.2,0.4-2.5,1.3-3.4c1.8-2.1,3.1-4.4,4-6.9
				c0.1-0.3,0.1-0.7-0.1-1c-0.2-0.3-0.5-0.5-0.9-0.5H18.2c-0.3,0-0.7,0.2-0.9,0.5c-0.2,0.3-0.2,0.6-0.1,1c0.9,2.4,2.2,4.7,4,6.9
				C22,20,22.4,21.2,22.4,22.4z"
          />
          <path
            d="M24.6,26.7c0-0.6-0.5-1.1-1.1-1.1s-1.1,0.5-1.1,1.1c0,1.5-0.9,3.1-2.6,4.3c-3.6,2.6-6.2,5.5-8,8.5
				c-0.2,0.3-0.2,0.7,0,1.1c0.2,0.3,0.5,0.5,0.9,0.5h21.4c0.4,0,0.7-0.2,0.9-0.5c0.2-0.3,0.2-0.7,0-1.1c-1.7-3-4.4-5.9-8-8.5
				C25.5,29.8,24.6,28.3,24.6,26.7z"
          />
          <path
            d="M42.2,42.7h-0.6C40.8,34.4,36,28,32.2,23.5C36,19,40.8,12.6,41.6,4.3h0.6c1.2,0,2.1-1,2.1-2.1
				c0-1.2-1-2.1-2.1-2.1H4.8C3.6,0,2.7,1,2.7,2.1c0,1.2,1,2.1,2.1,2.1h0.6C6.2,12.6,11,19,14.8,23.5C11,28,6.2,34.4,5.4,42.7H4.8
				c-1.2,0-2.1,1-2.1,2.1c0,1.2,1,2.1,2.1,2.1h2.7h32h2.7c1.2,0,2.1-1,2.1-2.1C44.3,43.7,43.4,42.7,42.2,42.7z M9.7,42.7
				c0.8-7.5,5.7-13.3,9.3-17.6l0.2-0.2c0.7-0.8,0.7-2,0-2.8l-0.2-0.2c-3.6-4.3-8.5-10.1-9.3-17.6h27.5c-0.8,7.5-5.7,13.3-9.3,17.6
				l-0.2,0.2c-0.7,0.8-0.7,2,0,2.8l0.2,0.2c3.6,4.3,8.5,10.1,9.3,17.6C37.3,42.7,9.7,42.7,9.7,42.7z"
          />
        </svg>
      );
    case "PARTI":
      return (
        <svg
          version="1.1"
          id="Calque_1"
          xmlns="http://www.w3.org/2000/svg"
          xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          width="26px"
          height="26px"
          fill="#8B00C5"
          viewBox="0 0 512 512"
          space="preserve"
        >
          <path d="M496,240H293.3c-8.8,0-16-7.2-16-16c0-8.8,7.2-16,16-16H496c8.8,0,16,7.2,16,16C512,232.8,504.8,240,496,240z" />
          <path
            d="M416,320c-4.1,0-8.2-1.6-11.3-4.7c-6.2-6.3-6.2-16.4,0-22.6l68.7-68.7l-68.7-68.7c-6.2-6.2-6.2-16.4,0-22.6
	c6.3-6.3,16.4-6.3,22.6,0l80,80c6.2,6.2,6.2,16.4,0,22.6l-80,80C424.2,318.4,420.1,320,416,320z"
          />
          <path
            d="M170.7,512c-4.6,0-8.9-0.6-13.2-2L29.1,467.2C11.6,461.1,0,444.9,0,426.7v-384C0,19.2,19.1,0,42.7,0
	c4.6,0,8.9,0.6,13.2,2l128.4,42.8c17.5,6.1,29.1,22.4,29.1,40.6v384C213.3,492.9,194.2,512,170.7,512z M42.7,32
	C36.8,32,32,36.8,32,42.7v384c0,4.5,3.1,8.8,7.4,10.3l127.8,42.6c0.9,0.3,2.1,0.5,3.5,0.5c5.9,0,10.7-4.8,10.7-10.7v-384
	c0-4.5-3.1-8.8-7.4-10.3L46.1,32.5C45.2,32.2,44,32,42.7,32z"
          />
          <path
            d="M325.3,170.7c-8.8,0-16-7.2-16-16v-96c0-14.7-12-26.7-26.7-26.7h-240c-8.8,0-16-7.2-16-16s7.2-16,16-16h240
	c32.4,0,58.7,26.3,58.7,58.7v96C341.3,163.5,334.2,170.7,325.3,170.7z"
          />
          <path
            d="M282.7,448h-85.3c-8.8,0-16-7.2-16-16s7.2-16,16-16h85.3c14.7,0,26.7-12,26.7-26.7v-96c0-8.8,7.2-16,16-16
	s16,7.2,16,16v96C341.3,421.7,315,448,282.7,448z"
          />
        </svg>
      );
    case "ABSENT":
      return (
        <svg
          version="1.1"
          id="Calque_1"
          xmlns="http://www.w3.org/2000/svg"
          xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          width="26px"
          fill="#ff7d26"
          height="26px"
          viewBox="0 0 50 50"
          space="preserve"
        >
          <path
            d="M45.7,6.5h-8.6V4.8c0-0.7-0.6-1.3-1.3-1.3c-0.7,0-1.3,0.6-1.3,1.3v1.7H15.6V4.8c0-0.7-0.6-1.3-1.3-1.3
	c-0.7,0-1.3,0.6-1.3,1.3v1.7H4.3C3.6,6.5,3,7.1,3,7.9v37.8C3,46.4,3.6,47,4.3,47h41.4c0.7,0,1.3-0.6,1.3-1.3c0-1.2,0-37.2,0-37.8
	C47.1,7.1,46.5,6.5,45.7,6.5z M44.4,44.3H5.7V18.9h38.8V44.3z M44.4,16.2H5.7v-7H13v1.7c0,0.7,0.6,1.3,1.3,1.3
	c0.7,0,1.3-0.6,1.3-1.3V9.2h18.8v1.7c0,0.7,0.6,1.3,1.3,1.3s1.3-0.6,1.3-1.3V9.2h7.3V16.2z"
          />
          <path
            d="M17,39.7c0.5,0.5,1.4,0.5,1.9,0l6.1-6.1l6.1,6.1c0.5,0.5,1.4,0.5,1.9,0c0.5-0.5,0.5-1.4,0-1.9l-6.1-6.1l6.1-6.1
	c0.5-0.5,0.5-1.4,0-1.9c-0.5-0.5-1.4-0.5-1.9,0L25,29.8l-6.1-6.1c-0.5-0.5-1.4-0.5-1.9,0c-0.5,0.5-0.5,1.4,0,1.9l6.1,6.1L17,37.9
	C16.5,38.4,16.5,39.2,17,39.7z"
          />
        </svg>
      );
    case "ARRIVEE":
      return (
        <svg
          version="1.1"
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          width="26px"
          height="26px"
          fill="#004CC5"
          viewBox="0 0 512 512"
          space="preserve"
        >
          <path
            class="st0"
            d="M270.9,283.3c0-7.4,6.1-13.5,13.5-13.5h170.5c7.4,0,13.5,6.1,13.5,13.5s-6.1,13.5-13.5,13.5H284.4
	C277,296.7,270.9,290.8,270.9,283.3z"
          />
          <path
            class="st0"
            d="M342.2,360.1l-67.3-67.3c-5.2-5.2-5.2-13.8,0-19l67.3-67.3c5.2-5.3,13.7-5.3,19,0c5.2,5.2,5.2,13.8,0,19
	l-57.8,57.8l57.7,57.8c5.2,5.2,5.2,13.7,0,19c-2.6,2.6-6.1,4-9.5,4C348.2,364,344.8,362.8,342.2,360.1z"
          />
          <path
            class="st0"
            d="M217.2,76.8v323c0,15.3-9.8,29-24.5,34.2l-108,36c-3.6,1.2-7.2,1.7-11.1,1.7c-19.9,0-35.9-16.2-35.9-35.9v-323
	c0-15.3,9.8-28.9,24.5-34.1l108-36c3.6-1.2,7.2-1.7,11.1-1.7C201,41,217.1,57.1,217.2,76.8z M76.4,444.4L184,408.5
	c3.6-1.3,6.2-4.9,6.2-8.7v-323c0-5-4-9-9-9c-1.2,0-2.2,0.2-2.9,0.4L70.8,104.1c-3.6,1.3-6.2,4.9-6.2,8.7v323c0,5,4,9,9,9
	C74.6,444.8,75.7,444.6,76.4,444.4z"
          />
          <path
            class="st0"
            d="M324.7,374.1v60.6c0,20.4-22.1,37-49.4,37H73.5c-7.4,0-13.5-4.5-13.5-10.1s6.1-10.1,13.5-10.1h201.9
	c12.4,0,22.5-7.6,22.5-16.8v-60.6c0-5.6,6.1-10.1,13.5-10.1C318.8,364,324.7,368.6,324.7,374.1z"
          />
          <path
            class="st0"
            d="M324.8,131.9v60.6c0,5.6-6.1,10.1-13.5,10.1s-13.5-4.5-13.5-10.1v-60.6c0-9.3-10.1-16.8-22.5-16.8h-71.8
	c-7.4,0-13.5-4.5-13.5-10.1c0-5.6,6.1-10.1,13.5-10.1h71.8C302.6,94.8,324.7,111.4,324.8,131.9z"
          />
        </svg>
      );
    case "DEPART":
      return (
        <svg
          version="1.1"
          id="Calque_1"
          xmlns="http://www.w3.org/2000/svg"
          xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          width="26px"
          height="26px"
          fill="#0B45EF"
          viewBox="0 0 50 50"
          space="preserve"
        >
          <path
            class="st0"
            d="M47.6,9.5c-2.9-2.9-8.2-5-11.8-6c-2.9-0.8-6.1-1.2-8.8-1.2c-1.7,0-3.2,0.2-4.5,0.5c-0.3,0.1-0.6,0.3-0.6,0.6
			c-0.3,1-0.5,2-0.7,3.1c0,0,0,0.1,0,0.1c-0.7,4.2-0.9,8.7-0.4,12.6c-2.3,0.1-4.7,0.5-6.9,1.1c-3.7,1-9,3.1-11.8,6
			c-0.2,0.2-0.3,0.6-0.2,0.9c0.3,1.1,0.6,2.2,1,3.3c0,0,0,0,0,0c1.4,3.8,3.4,7.6,5.7,10.6c2.5,3.3,6.4,7.2,10.9,7.2
			c0.6,0,1.3-0.1,1.9-0.3c2.7-0.7,4.9-3,6.2-6.6c1-2.7,1.6-6.2,1.6-10c0.4,0.1,0.7,0.1,1.1,0.1c4.5,0,8.4-3.9,10.9-7.2
			c2.9-3.9,5.5-9.1,6.7-13.9C47.9,10.1,47.8,9.8,47.6,9.5z M20.9,46.4c-0.5,0.1-1,0.2-1.4,0.2c-2.9,0-6.3-2.3-9.4-6.5
			c-2.1-2.8-3.9-6.2-5.2-9.6c0.5-0.4,1.3-1,2.1-1.5c0.4-0.3,0.5-0.8,0.2-1.2c-0.3-0.4-0.8-0.5-1.2-0.2c-0.6,0.4-1.2,0.9-1.7,1.2
			c-0.2-0.5-0.3-0.9-0.4-1.4c2.2-2,6.4-4.1,10.7-5.2c2.2-0.6,4.5-1,6.7-1.1c0.3,1.5,0.7,2.9,1.2,4.1c0,0,0,0,0,0
			c0,0.1,0.1,0.2,0.1,0.3c0,0,0,0,0,0c0.2,0.6,0.5,1.1,0.8,1.6c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0.1,0.1,0.1c0,0.1,0.1,0.1,0.1,0.2
			c0,0,0,0.1,0.1,0.1c0.1,0.1,0.1,0.2,0.2,0.2c0,0,0.1,0.1,0.1,0.1c0.1,0.1,0.1,0.2,0.2,0.2c0,0,0,0.1,0.1,0.1
			c0.1,0.1,0.1,0.2,0.2,0.2c0,0,0,0,0,0c0.1,0.1,0.2,0.3,0.4,0.4c-0.5,0.7-1.4,1.1-2.3,1.1c-1,0-2-0.6-2.5-1.4
			c-0.2-0.4-0.8-0.6-1.2-0.3c-0.4,0.2-0.6,0.8-0.3,1.2c0.8,1.4,2.4,2.3,4.1,2.3c1.4,0,2.7-0.6,3.6-1.7c0.3,0.2,0.6,0.4,0.9,0.6
			c0,0,0,0,0,0c0.1,0,0.2,0.1,0.3,0.1c0,0,0,0,0.1,0c0.1,0,0.2,0.1,0.2,0.1c0,0,0,0,0,0C27.4,37.7,25.7,45.1,20.9,46.4z M39.7,23.2
			c-3.1,4.2-6.5,6.5-9.4,6.5c-0.5,0-1-0.1-1.4-0.2c-0.1,0-0.2,0-0.3-0.1c0,0,0,0,0,0c-3.9-1.3-5.3-6.5-5.8-9.5c0,0,0,0,0,0
			c0-0.1,0-0.1,0-0.2c-0.6-3.7-0.5-8.1,0.1-12.2c0.6-0.1,1.6-0.2,2.5-0.3c0.5,0,0.9-0.5,0.8-1c0-0.5-0.5-0.9-1-0.8
			c-0.7,0.1-1.5,0.1-2.1,0.2c0.1-0.4,0.2-0.8,0.3-1.2c1-0.2,2.2-0.3,3.5-0.3c2.6,0,5.6,0.4,8.3,1.1c4.2,1.1,8.4,3.2,10.7,5.2
			C44.7,14.9,42.4,19.6,39.7,23.2z"
          />
        </svg>
      );
    default:
      return <path />;
  }
};

//histo medi
export const EnfantEventSante = ({ size = "40px", classCSS }) => (
  <SVG
    data={srcIconHistoriqueMedical}
    type="image/svg+xml"
    className={`img-fluid ${classCSS}`}
    style={{
      width: size,
      cursor: "pointer",
      pointerEvents: "none",
      zIndex: -1,
    }}
  />
);

//Sieste
export const EnfantSieste = ({ size = "40px", classCSS }) => (
  <SVG
    data={srcIconSieste}
    type="image/svg+xml"
    className={`img-fluid ${classCSS}`}
    style={{
      width: size,
      cursor: "pointer",
      pointerEvents: "none",
      zIndex: -1,
    }}
  />
);

//PetitCoin
export const EnfantPetitCoin = ({ size = "40px", classCSS }) => (
  <SVG
    data={srcIconPetitCoin}
    type="image/svg+xml"
    className={`img-fluid ${classCSS}`}
    style={{
      width: size,
      cursor: "pointer",
      pointerEvents: "none",
      zIndex: -1,
    }}
  />
);
//Repas
export const EnfantRepas = ({ size = "40px", classCSS }) => (
  <SVG
    data={srcIconRepas}
    type="image/svg+xml"
    className={`img-fluid ${classCSS}`}
    style={{
      width: size,
      cursor: "pointer",
      pointerEvents: "none",
      zIndex: -1,
    }}
  />
);
export const EnfantBiberon = ({ size = "40px", classCSS }) => (
  <SVG
    data={srcIconBiberon}
    type="image/svg+xml"
    className={`img-fluid ${classCSS}`}
    style={{
      width: size,
      cursor: "pointer",
      pointerEvents: "none",
      zIndex: -1,
    }}
  />
);

export const EnfantSortie = ({ size = "40px", classCSS }) => (
  <SVG
    data={srcIconSortie}
    type="image/svg+xml"
    className={`img-fluid ${classCSS}`}
    style={{
      width: size,
      cursor: "pointer",
      pointerEvents: "none",
      zIndex: -1,
    }}
  />
);

export const EnfantAbsent = ({ size = "40px", classCSS }) => (
  <SVG
    data={srcEnfantAbsent}
    type="image/svg+xml"
    className={`img-fluid ${classCSS}`}
    style={{
      width: size,
      cursor: "pointer",
      pointerEvents: "none",
      zIndex: -1,
    }}
  />
);
export const EnfantAttendu = ({ size = "40px", classCSS }) => (
  <SVG
    data={srcEnfantAttendu}
    type="image/svg+xml"
    className={`img-fluid ${classCSS}`}
    style={{
      width: size,
      cursor: "pointer",
      pointerEvents: "none",
      zIndex: -1,
    }}
  />
);
export const EnfantParti = ({ size = "40px", classCSS }) => (
  <SVG
    data={srcEnfantParti}
    type="image/svg+xml"
    className={`img-fluid ${classCSS}`}
    style={{
      width: size,
      cursor: "pointer",
      pointerEvents: "none",
      zIndex: -1,
    }}
  />
);
export const EnfantPresent = ({ size = "40px", classCSS }) => (
  <SVG
    data={srcEnfantPresent}
    type="image/svg+xml"
    className={`img-fluid ${classCSS}`}
    style={{
      width: size,
      cursor: "pointer",
      pointerEvents: "none",
      zIndex: -1,
    }}
  />
);
export const EnfantArrive = ({ size = "40px", classCSS }) => (
  <SVG
    data={srcEnfantArrive}
    type="image/svg+xml"
    className={`img-fluid ${classCSS}`}
    style={{
      width: size,
      cursor: "pointer",
      pointerEvents: "none",
      zIndex: -1,
    }}
  />
);

export const EnfantPateModule = ({ size = "40px", classCSS }) => (
  <SVG
    data={srcIconPateAModule}
    type="image/svg+xml"
    className={`img-fluid ${classCSS}`}
    style={{
      width: size,
      cursor: "pointer",
      pointerEvents: "none",
      zIndex: -1,
    }}
  />
);
export const EnfantPienture = ({ size = "40px", classCSS }) => (
  <SVG
    data={srcIconPienture}
    type="image/svg+xml"
    className={`img-fluid ${classCSS}`}
    style={{
      width: size,
      cursor: "pointer",
      pointerEvents: "none",
      zIndex: -1,
    }}
  />
);
export const EnfantDanse = ({ size = "40px", classCSS }) => (
  <SVG
    data={srcIconDanse}
    type="image/svg+xml"
    className={`img-fluid ${classCSS}`}
    style={{
      width: size,
      cursor: "pointer",
      pointerEvents: "none",
      zIndex: -1,
    }}
  />
);
export const EnfantPiscine = ({ size = "40px", classCSS }) => (
  <SVG
    data={srcIconPiscine}
    type="image/svg+xml"
    className={`img-fluid ${classCSS}`}
    style={{
      width: size,
      cursor: "pointer",
      pointerEvents: "none",
      zIndex: -1,
    }}
  />
);
export const EnfantLecture = ({ size = "40px", classCSS }) => (
  <SVG
    data={srcIconLecture}
    type="image/svg+xml"
    className={`img-fluid ${classCSS}`}
    style={{
      width: size,
      cursor: "pointer",
      pointerEvents: "none",
      zIndex: -1,
    }}
  />
);
export const EnfantActiviteManuelle = ({ size = "40px", classCSS }) => (
  <SVG
    data={srcIconActiviteManuelle}
    type="image/svg+xml"
    className={`img-fluid ${classCSS}`}
    style={{
      width: size,
      cursor: "pointer",
      pointerEvents: "none",
      zIndex: -1,
    }}
  />
);
export const EnfantAutre = ({ size = "40px", classCSS }) => (
  <SVG
    data={srcIconAutre}
    type="image/svg+xml"
    className={`img-fluid ${classCSS}`}
    style={{
      width: size,
      cursor: "pointer",
      pointerEvents: "none",
      zIndex: -1,
    }}
  />
);

export const EnfantFievre = ({ size = "40px", classCSS }) => (
  <SVG
    data={srcIconFievre}
    type="image/svg+xml"
    className={`img-fluid ${classCSS}`}
    style={{
      width: size,
      cursor: "pointer",
      pointerEvents: "none",
      zIndex: -1,
    }}
  />
);
export const EnfantVomi = ({ size = "40px", classCSS }) => (
  <SVG
    data={srcIconVomi}
    type="image/svg+xml"
    className={`img-fluid ${classCSS}`}
    style={{
      width: size,
      cursor: "pointer",
      pointerEvents: "none",
      zIndex: -1,
    }}
  />
);
export const EnfantToux = ({ size = "40px", classCSS }) => (
  <SVG
    data={srcIconToux}
    type="image/svg+xml"
    className={`img-fluid ${classCSS}`}
    style={{
      width: size,
      cursor: "pointer",
      pointerEvents: "none",
      zIndex: -1,
    }}
  />
);
export const EnfantBlessure = ({ size = "40px", classCSS }) => (
  <SVG
    data={srcIconblessure}
    type="image/svg+xml"
    className={`img-fluid ${classCSS}`}
    style={{
      width: size,
      cursor: "pointer",
      pointerEvents: "none",
      zIndex: -1,
    }}
  />
);
export const EnfantBoutons = ({ size = "40px", classCSS }) => (
  <SVG
    data={srcIconBoutons}
    type="image/svg+xml"
    className={`img-fluid ${classCSS}`}
    style={{
      width: size,
      cursor: "pointer",
      pointerEvents: "none",
      zIndex: -1,
    }}
  />
);

//MINI clickable
export const EnfantEventSanteMINI = ({
  size = "40px",
  classCSS,
  handleClick,
  event,
}) => (
  <span
    style={{ zIndex: 1, display: "inline-block" }}
    onClick={() => handleClick(event)}
  >
    <object
      data={srcIconHistoriqueMedical}
      type="image/svg+xml"
      className={`img-fluid ${classCSS}`}
      style={{
        width: size,
        cursor: "pointer",
        pointerEvents: "none",
        zIndex: -1,
      }}
    />
  </span>
);
export const EnfantSiesteMINI = ({
  size = "40px",
  classCSS,
  handleClick,
  event,
}) => (
  <span
    style={{ zIndex: 1, display: "inline-block" }}
    onClick={() => handleClick(event)}
  >
    <object
      data={srcIconSieste}
      type="image/svg+xml"
      className={`img-fluid ${classCSS}`}
      style={{
        width: size,
        cursor: "pointer",
        pointerEvents: "none",
        zIndex: -1,
      }}
    />
  </span>
);
export const EnfantPetitCoinMINI = ({
  size = "40px",
  classCSS,
  handleClick,
  event,
}) => (
  <span
    style={{ zIndex: 1, display: "inline-block" }}
    onClick={() => handleClick(event)}
  >
    <object
      data={srcIconPetitCoin}
      type="image/svg+xml"
      className={`img-fluid ${classCSS}`}
      style={{
        width: size,
        cursor: "pointer",
        pointerEvents: "none",
        zIndex: -1,
      }}
    />
  </span>
);
export const EnfantRepasMINI = ({
  size = "40px",
  classCSS,
  handleClick,
  event,
}) => (
  <span
    style={{ zIndex: 1, display: "inline-block" }}
    onClick={() => handleClick(event)}
  >
    <object
      data={srcIconRepas}
      type="image/svg+xml"
      className={`img-fluid ${classCSS}`}
      style={{
        width: size,
        cursor: "pointer",
        pointerEvents: "none",
        zIndex: -1,
      }}
    />
  </span>
);
export const EnfantBiberonMINI = ({
  size = "40px",
  classCSS,
  handleClick,
  event,
}) => (
  <span
    style={{ zIndex: 1, display: "inline-block" }}
    onClick={() => handleClick(event)}
  >
    <object
      data={srcIconBiberon}
      type="image/svg+xml"
      className={`img-fluid ${classCSS}`}
      style={{
        width: size,
        cursor: "pointer",
        pointerEvents: "none",
        zIndex: -1,
      }}
    />
  </span>
);

export const EnfantSortieMINI = ({
  size = "40px",
  classCSS,
  handleClick,
  event,
}) => (
  <span
    style={{ zIndex: 1, display: "inline-block" }}
    onClick={() => handleClick(event)}
  >
    <object
      data={srcIconSortie}
      type="image/svg+xml"
      className={`img-fluid ${classCSS}`}
      style={{
        width: size,
        cursor: "pointer",
        pointerEvents: "none",
        zIndex: -1,
      }}
    />
  </span>
);

export const EnfantAbsentMINI = ({
  size = "40px",
  classCSS,
  handleClick,
  event,
}) => (
  <span
    style={{ zIndex: 1, display: "inline-block" }}
    onClick={() => handleClick(event)}
  >
    <object
      data={srcEnfantAbsent}
      type="image/svg+xml"
      className={`img-fluid ${classCSS}`}
      style={{
        width: size,
        cursor: "pointer",
        pointerEvents: "none",
        zIndex: -1,
      }}
    />
  </span>
);
export const EnfantAttenduMINI = ({
  size = "40px",
  classCSS,
  handleClick,
  event,
}) => (
  <span
    style={{ zIndex: 1, display: "inline-block" }}
    onClick={() => handleClick(event)}
  >
    <object
      data={srcEnfantAttendu}
      type="image/svg+xml"
      className={`img-fluid ${classCSS}`}
      style={{
        width: size,
        cursor: "pointer",
        pointerEvents: "none",
        zIndex: -1,
      }}
    />
  </span>
);
export const EnfantPartiMINI = ({
  size = "40px",
  classCSS,
  handleClick,
  event,
}) => (
  <span
    style={{ zIndex: 1, display: "inline-block" }}
    onClick={() => handleClick(event)}
  >
    <object
      data={srcEnfantSortie}
      type="image/svg+xml"
      className={`img-fluid ${classCSS}`}
      style={{
        width: size,
        cursor: "pointer",
        pointerEvents: "none",
        zIndex: -1,
      }}
    />
  </span>
);
export const EnfantPresentMINI = ({
  size = "40px",
  classCSS,
  handleClick,
  event,
}) => (
  <span
    style={{ zIndex: 1, display: "inline-block" }}
    onClick={() => handleClick(event)}
  >
    <object
      data={srcEnfantPresent}
      type="image/svg+xml"
      className={`img-fluid ${classCSS}`}
      style={{
        width: size,
        cursor: "pointer",
        pointerEvents: "none",
        zIndex: -1,
      }}
    />
  </span>
);
export const EnfantArriveMINI = ({
  size = "40px",
  classCSS,
  handleClick,
  event,
}) => (
  <span
    style={{ zIndex: 1, display: "inline-block" }}
    onClick={() => handleClick(event)}
  >
    <object
      data={srcEnfantArrive}
      type="image/svg+xml"
      className={`img-fluid ${classCSS}`}
      style={{
        width: size,
        cursor: "pointer",
        pointerEvents: "none",
        zIndex: -1,
      }}
    />
  </span>
);

export const EnfantPateModuleMINI = ({
  size = "40px",
  classCSS,
  handleClick,
  event,
}) => (
  <span
    style={{ zIndex: 1, display: "inline-block" }}
    onClick={() => handleClick(event)}
  >
    <object
      data={srcIconPateAModule}
      type="image/svg+xml"
      className={`img-fluid ${classCSS}`}
      style={{
        width: size,
        cursor: "pointer",
        pointerEvents: "none",
        zIndex: -1,
      }}
    />
  </span>
);
export const EnfantPientureMINI = ({
  size = "40px",
  classCSS,
  handleClick,
  event,
}) => (
  <span
    style={{ zIndex: 1, display: "inline-block" }}
    onClick={() => handleClick(event)}
  >
    <object
      data={srcIconPienture}
      type="image/svg+xml"
      className={`img-fluid ${classCSS}`}
      style={{
        width: size,
        cursor: "pointer",
        pointerEvents: "none",
        zIndex: -1,
      }}
    />
  </span>
);
export const EnfantDanseMINI = ({
  size = "40px",
  classCSS,
  handleClick,
  event,
}) => (
  <span
    style={{ zIndex: 1, display: "inline-block" }}
    onClick={() => handleClick(event)}
  >
    <object
      data={srcIconDanse}
      type="image/svg+xml"
      className={`img-fluid ${classCSS}`}
      style={{
        width: size,
        cursor: "pointer",
        pointerEvents: "none",
        zIndex: -1,
      }}
    />
  </span>
);
export const EnfantPiscineMINI = ({
  size = "40px",
  classCSS,
  handleClick,
  event,
}) => (
  <span
    style={{ zIndex: 1, display: "inline-block" }}
    onClick={() => handleClick(event)}
  >
    <object
      data={srcIconPiscine}
      type="image/svg+xml"
      className={`img-fluid ${classCSS}`}
      style={{
        width: size,
        cursor: "pointer",
        pointerEvents: "none",
        zIndex: -1,
      }}
    />
  </span>
);
export const EnfantLectureMINI = ({
  size = "40px",
  classCSS,
  handleClick,
  event,
}) => (
  <span
    style={{ zIndex: 1, display: "inline-block" }}
    onClick={() => handleClick(event)}
  >
    <object
      data={srcIconLecture}
      type="image/svg+xml"
      className={`img-fluid ${classCSS}`}
      style={{
        width: size,
        cursor: "pointer",
        pointerEvents: "none",
        zIndex: -1,
      }}
    />
  </span>
);
export const EnfantActiviteManuelleMINI = ({
  size = "40px",
  classCSS,
  handleClick,
  event,
}) => (
  <span
    style={{ zIndex: 1, display: "inline-block" }}
    onClick={() => handleClick(event)}
  >
    <object
      data={srcIconActiviteManuelle}
      type="image/svg+xml"
      className={`img-fluid ${classCSS}`}
      style={{
        width: size,
        cursor: "pointer",
        pointerEvents: "none",
        zIndex: -1,
      }}
    />
  </span>
);
export const EnfantAutreActiviteMINI = ({
  size = "40px",
  classCSS,
  handleClick,
  event,
}) => (
  <span
    style={{ zIndex: 1, display: "inline-block" }}
    onClick={() => handleClick(event)}
  >
    <object
      data={srcActivite}
      type="image/svg+xml"
      className={`img-fluid ${classCSS}`}
      style={{
        width: size,
        cursor: "pointer",
        pointerEvents: "none",
        zIndex: -1,
      }}
    />
  </span>
);

export const EnfantFievreMINI = ({
  size = "40px",
  classCSS,
  handleClick,
  event,
}) => (
  <span
    style={{ zIndex: 1, display: "inline-block" }}
    onClick={() => handleClick(event)}
  >
    <object
      data={srcIconFievre}
      type="image/svg+xml"
      className={`img-fluid ${classCSS}`}
      style={{
        width: size,
        cursor: "pointer",
        pointerEvents: "none",
        zIndex: -1,
      }}
    />
  </span>
);
export const EnfantVomiMINI = ({
  size = "40px",
  classCSS,
  handleClick,
  event,
}) => (
  <span
    style={{ zIndex: 1, display: "inline-block" }}
    onClick={() => handleClick(event)}
  >
    <object
      data={srcIconVomi}
      type="image/svg+xml"
      className={`img-fluid ${classCSS}`}
      style={{
        width: size,
        cursor: "pointer",
        pointerEvents: "none",
        zIndex: -1,
      }}
    />
  </span>
);
export const EnfantTouxMINI = ({
  size = "40px",
  classCSS,
  handleClick,
  event,
}) => (
  <span
    style={{ zIndex: 1, display: "inline-block" }}
    onClick={() => handleClick(event)}
  >
    <object
      data={srcIconToux}
      type="image/svg+xml"
      className={`img-fluid ${classCSS}`}
      style={{
        width: size,
        cursor: "pointer",
        pointerEvents: "none",
        zIndex: -1,
      }}
    />
  </span>
);
export const EnfantBlessureMINI = ({
  size = "40px",
  classCSS,
  handleClick,
  event,
}) => (
  <span
    style={{ zIndex: 1, display: "inline-block" }}
    onClick={() => handleClick(event)}
  >
    <object
      data={srcIconblessure}
      type="image/svg+xml"
      className={`img-fluid ${classCSS}`}
      style={{
        width: size,
        cursor: "pointer",
        pointerEvents: "none",
        zIndex: -1,
      }}
    />
  </span>
);
export const EnfantBoutonsMINI = ({
  size = "40px",
  classCSS,
  handleClick,
  event,
}) => (
  <span
    style={{ zIndex: 1, display: "inline-block" }}
    onClick={() => handleClick(event)}
  >
    <object
      data={srcIconBoutons}
      type="image/svg+xml"
      className={`img-fluid ${classCSS}`}
      style={{
        width: size,
        cursor: "pointer",
        pointerEvents: "none",
        zIndex: -1,
      }}
    />
  </span>
);

export function getStatusToString(statut, time, t) {
  if (t) {
    var formattedTime = moment(time).format('HH:mm');
    if (statut === "PRESENT") return t('status.arrived_at', { time: formattedTime });
    if (statut === "PARTI") return t('status.left_at', { time: formattedTime });
    if (statut === "ATTENDU") return t('status.expected');
    return t('status.absent');
  }
  return statut == "PRESENT"
    ? "Arrivé" +
        " à " +
        moment(time).format("h") +
        "h" +
        moment(time).format("mm")
    : statut == "PARTI"
    ? "Parti" +
      " à " +
      moment(time).format("h") +
      "h" +
      moment(time).format("mm")
    : statut == "ATTENDU"
    ? "Attendu"
    : "Absent";
}
export function getEtatSanteToString(ObjetSante, time, t) {
  if (t) {
    switch (ObjetSante) {
      case "FIEVRE": return t('health.fever');
      case "VOMI": return t('health.vomit');
      case "TOUX": return t('health.cough');
      case "BLESSURE": return t('health.injury');
      case "BOUTONS": return t('health.rash');
      case "AUTRE": return t('health.other');
      default: return "";
    }
  }
  return ObjetSante === "FIEVRE"
    ? "Fièvre"
    : ObjetSante == "VOMI"
    ? "Vomi"
    : ObjetSante == "TOUX"
    ? "Toux"
    : ObjetSante == "BLESSURE"
    ? "Blessure"
    : ObjetSante == "BOUTONS"
    ? "BOUTONS"
    : ObjetSante == "AUTRE"
    ? "AUTRE"
    : "";
}

export function getPetitCoinToString(categorie, t) {
  if (t) {
    return categorie === "PETITE_COMMISSION" ? t('timeline.stool') : t('timeline.pee');
  }
  return categorie === "PETITE_COMMISSION" ? "Selles" : "Pipi";
}

export function getActiviteToString(statut, time) {
  return statut == "PATE_A_MODELER"
    ? "PATE_A_MODELER" +
        " à " +
        moment(time).format("h") +
        "h" +
        moment(time).format("mm")
    : statut == "PEINTURE"
    ? "PEINTURE" +
      " à " +
      moment(time).format("h") +
      "h" +
      moment(time).format("mm")
    : statut == "DANSE"
    ? "DANSE" +
      " à " +
      moment(time).format("h") +
      "h" +
      moment(time).format("mm")
    : statut == "SORTIE"
    ? "SORTIE" +
      " à " +
      moment(time).format("h") +
      "h" +
      moment(time).format("mm")
    : statut == "PISCINE"
    ? "PISCINE" +
      " à " +
      moment(time).format("h") +
      "h" +
      moment(time).format("mm")
    : statut == "LECTURE"
    ? "LECTURE" +
      " à " +
      moment(time).format("h") +
      "h" +
      moment(time).format("mm")
    : statut == "ACTIVITE_MANUELLE"
    ? "ACTIVITE_MANUELLE" +
      " à " +
      moment(time).format("h") +
      "h" +
      moment(time).format("mm")
    : "Rien";
}

export function getRepasToString(type, time) {
  return type == "REPAS_PEU"
    ? " À " + moment(time).format("h") + "h" + moment(time).format("mm")
    : type == "REPAS_CORRECTEMENT"
    ? " À " + moment(time).format("h") + "h" + moment(time).format("mm")
    : type == "REPAS_BEAUCOUP"
    ? " À " + moment(time).format("h") + "h" + moment(time).format("mm")
    : " À " + moment(time).format("h") + "h" + moment(time).format("mm");
}

export function getDiversification(type, t) {
  if (t) {
    return type === "ENCOURS"
      ? t('fiche_enfant.aliments.in_progress')
      : type === "TERMINER"
      ? t('fiche_enfant.aliments.completed')
      : t('fiche_enfant.aliments.not_started');
  }
  return type === "ENCOURS"
    ? "en cours"
    : type === "TERMINER"
    ? "effective"
    : "pas encore commencée";
}

//Converti time en foramt (HH h MM)
export function convTime(time) {
  return moment(time).format("HH[h]MM");
}
// Differance entre deux temps
export function deltaTime(time1, time2) {
  let Delta = moment(time1).diff(moment(time2));
  return convTime(Delta);
}

//Fonction statuEnfant
export function enfantStatuSwitch(statut, size, classCSS) {
  switch (statut) {
    case "PRESENT":
      return <EnfantPresent size={size} classCSS={classCSS} />;
    case "ATTENDU":
      return <EnfantAttendu size={size} classCSS={classCSS} />;
    case "PARTI":
      return <EnfantParti size={size} classCSS={classCSS} />;
    case "ABSENT":
      return <EnfantAbsent size={size} classCSS={classCSS} />;
    case "ARRIVEE":
      return <EnfantPresent size={size} classCSS={classCSS} />;
    case "DEPART":
      return <EnfantParti size={size} classCSS={classCSS} />;
    default:
      return "";
  }
}
//Fonction objet Sante dans la nav Current
export function iconSanteSwitch(objetSante, size, classCSS) {
  switch (objetSante) {
    case "FIEVRE":
      return <EnfantFievre size={size} classCSS={classCSS} />;
    case "VOMI":
      return <EnfantVomi size={size} classCSS={classCSS} />;
    case "TOUX":
      return <EnfantToux size={size} classCSS={classCSS} />;
    case "BLESSURE":
      return <EnfantBlessure size={size} classCSS={classCSS} />;
    case "BOUTONS":
      return <EnfantBoutons size={size} classCSS={classCSS} />;
    case "AUTRE":
      return <EnfantAutre size={size} classCSS={classCSS} />;
    default:
      return "";
  }
}
//Fonction objet Sante dans la nav Current

export function getObjetSanteToString(etatSante, t) {
  if (t) {
    switch (etatSante) {
      case "RIEN_DE_GRAVE": return t('health.nothing_serious');
      case "A_SURVEILLER": return t('health.monitor');
      case "INQUIETANT": return t('health.worrying');
      default: return "";
    }
  }
  return etatSante === "RIEN_DE_GRAVE"
    ? "Rien de grave"
    : etatSante == "A_SURVEILLER"
    ? "À surveiller"
    : etatSante == "INQUIETANT"
    ? "Inquiétant"
    : "";
}
export function iconRepaSwitch(type, size, classCSS) {
  switch (type) {
    case "PEU":
      return <EnfantRepas size={size} classCSS={classCSS} />;
    case "CORRECTEMENT":
      return <EnfantRepas size={size} classCSS={classCSS} />;
    case "BEAUCOUP":
      return <EnfantRepas size={size} classCSS={classCSS} />;
    case "BIBERON":
      return <EnfantBiberon size={size} classCSS={classCSS} />;
    default:
      return "";
  }
}
export function RepaSwitch(type, t) {
  if (t) {
    const map = {
      "PEU": t('timeline.ate_little'),
      "CORRECTEMENT": t('timeline.ate_well'),
      "BEAUCOUP": t('timeline.ate_a_lot')
    };
    return map[type] || "";
  }
  return type === "PEU"
    ? "Peu mangé"
    : type == "CORRECTEMENT"
    ? "Correctement mangé"
    : type == "BEAUCOUP"
    ? "Beaucoup mangé"
    : "";
}

export function iconActiviteSwitch(typeActivite, size, classCSS) {
  switch (typeActivite) {
    case "PATE_A_MODELER":
      return <EnfantPateModule size={size} classCSS={classCSS} />;
    case "PEINTURE":
      return <EnfantPienture size={size} classCSS={classCSS} />;
    case "DANSE":
      return <EnfantDanse size={size} classCSS={classCSS} />;
    case "SORTIE":
      return <EnfantSortie size={size} classCSS={classCSS} />;
    case "PISCINE":
      return <EnfantPiscine size={size} classCSS={classCSS} />;
    case "LECTURE":
      return <EnfantLecture size={size} classCSS={classCSS} />;
    case "ACTIVITE_MANUELLE":
      return <EnfantActiviteManuelle size={size} classCSS={classCSS} />;
    case "PRESENT":
      return <EnfantPresent size={size} classCSS={classCSS} />;
    case "ATTENDU":
      return <EnfantAttendu size={size} classCSS={classCSS} />;
    case "PARTI":
      return <EnfantParti size={size} classCSS={classCSS} />;
    case "ABSENT":
      return <EnfantAbsent size={size} classCSS={classCSS} />;
    case "ARRIVEE":
      return <EnfantPresent size={size} classCSS={classCSS} />;
    case "DEPART":
      return <EnfantParti size={size} classCSS={classCSS} />;
    case "AUTRE":
      return <EnfantAutre size={size} classCSS={classCSS} />;
    default:
      return "";
  }
}

//Function switch all MINI icons
export function MINI_iconEVENTSwitch(event, size, classCSS, handleClick) {
  let typeEvent = event.typeEvent;
  switch (typeEvent) {
    case "ARRIVEE":
      return (
        <EnfantArriveMINI
          key={event.idEvent}
          size={size}
          classCSS={classCSS}
          handleClick={handleClick}
          event={event}
        />
      );
    case "DEPART":
      return (
        <EnfantPartiMINI
          key={event.idEvent}
          size={size}
          classCSS={classCSS}
          handleClick={handleClick}
          event={event}
        />
      );
    case "SIESTE":
      return (
        <EnfantSiesteMINI
          key={event.idEvent}
          size={size}
          classCSS={classCSS}
          handleClick={handleClick}
          event={event}
        />
      );
    case "REPAS_PEU":
      return (
        <EnfantRepasMINI
          key={event.idEvent}
          size={size}
          classCSS={classCSS}
          handleClick={handleClick}
          event={event}
        />
      );
    case "REPAS_CORRECTEMENT":
      return (
        <EnfantRepasMINI
          key={event.idEvent}
          size={size}
          classCSS={classCSS}
          handleClick={handleClick}
          event={event}
        />
      );
    case "REPAS_BEAUCOUP":
      return (
        <EnfantRepasMINI
          key={event.idEvent}
          size={size}
          classCSS={classCSS}
          handleClick={handleClick}
          event={event}
        />
      );
    case "BIBERON":
      return (
        <EnfantBiberonMINI
          key={event.idEvent}
          size={size}
          classCSS={classCSS}
          handleClick={handleClick}
          event={event}
        />
      );
    case "NEXT_BIBERON":
      return (
        <EnfantBiberonMINI
          key={event.idEvent}
          size={size}
          classCSS={classCSS}
          handleClick={handleClick}
          event={event}
        />
      );
    case "PETITE_COMMISSION":
      return (
        <EnfantPetitCoinMINI
          key={event.idEvent}
          size={size}
          classCSS={classCSS}
          handleClick={handleClick}
          event={event}
        />
      );
    case "GROSSE_COMMISSION":
      return (
        <EnfantPetitCoinMINI
          key={event.idEvent}
          size={size}
          classCSS={classCSS}
          handleClick={handleClick}
          event={event}
        />
      );
    case "INCIDENT":
      return (
        <EnfantEventSanteMINI
          key={event.idEvent}
          size={size}
          classCSS={classCSS}
          handleClick={handleClick}
          event={event}
        />
      );
    case "FIEVRE":
      return (
        <EnfantFievreMINI
          key={event.idEvent}
          size={size}
          classCSS={classCSS}
          handleClick={handleClick}
          event={event}
        />
      );
    case "VOMI":
      return (
        <EnfantVomiMINI
          key={event.idEvent}
          size={size}
          classCSS={classCSS}
          handleClick={handleClick}
          event={event}
        />
      );
    case "TOUX":
      return (
        <EnfantTouxMINI
          key={event.idEvent}
          size={size}
          classCSS={classCSS}
          handleClick={handleClick}
          event={event}
        />
      );
    case "BLESSURE":
      return (
        <EnfantBlessureMINI
          key={event.idEvent}
          size={size}
          classCSS={classCSS}
          handleClick={handleClick}
          event={event}
        />
      );
    case "BOUTONS":
      return (
        <EnfantBoutonsMINI
          key={event.idEvent}
          size={size}
          classCSS={classCSS}
          handleClick={handleClick}
          event={event}
        />
      );
    case "PATE_A_MODELER":
      return (
        <EnfantPateModuleMINI
          key={event.idEvent}
          size={size}
          classCSS={classCSS}
          handleClick={handleClick}
          event={event}
        />
      );
    case "PEINTURE":
      return (
        <EnfantPientureMINI
          key={event.idEvent}
          size={size}
          classCSS={classCSS}
          handleClick={handleClick}
          event={event}
        />
      );
    case "DANSE":
      return (
        <EnfantDanseMINI
          key={event.idEvent}
          size={size}
          classCSS={classCSS}
          handleClick={handleClick}
          event={event}
        />
      );
    case "SORTIE":
      return (
        <EnfantSortieMINI
          key={event.idEvent}
          size={size}
          classCSS={classCSS}
          handleClick={handleClick}
          event={event}
        />
      );
    case "PISCINE":
      return (
        <EnfantPiscineMINI
          key={event.idEvent}
          size={size}
          classCSS={classCSS}
          handleClick={handleClick}
          event={event}
        />
      );
    case "LECTURE":
      return (
        <EnfantLectureMINI
          key={event.idEvent}
          size={size}
          classCSS={classCSS}
          handleClick={handleClick}
          event={event}
        />
      );
    case "ACTIVITE_MANUELLE":
      return (
        <EnfantActiviteManuelleMINI
          key={event.idEvent}
          size={size}
          classCSS={classCSS}
          handleClick={handleClick}
          event={event}
        />
      );
    case "ACTIVITE":
      return (
        <EnfantAutreActiviteMINI
          key={event.idEvent}
          size={size}
          classCSS={classCSS}
          handleClick={handleClick}
          event={event}
        />
      );
    default:
      return "";
  }
}

//Function switch all icons
export function iconEVENTSwitch(event, size, classCSS) {
  let typeEvent = event.typeEvent;
  switch (typeEvent) {
    case "ARRIVEE":
      return <EnfantArrive size={size} classCSS={classCSS} />;
    case "DEPART":
      return <EnfantParti size={size} classCSS={classCSS} />;
    case "SIESTE":
      return <EnfantSieste size={size} classCSS={classCSS} />;
    case "REPAS_PEU":
      return <EnfantRepas size={size} classCSS={classCSS} />;
    case "REPAS_CORRECTEMENT":
      return <EnfantRepas size={size} classCSS={classCSS} />;
    case "REPAS_BEAUCOUP":
      return <EnfantRepas size={size} classCSS={classCSS} />;
    case "BIBERON":
      return <EnfantBiberon size={size} classCSS={classCSS} />;
    case "NEXT_BIBERON":
      return <EnfantBiberon size={size} classCSS={classCSS} />;
    case "PETITE_COMMISSION":
      return <EnfantPetitCoin size={size} classCSS={classCSS} />;
    case "GROSSE_COMMISSION":
      return <EnfantPetitCoin size={size} classCSS={classCSS} />;
    case "INCIDENT":
      return <EnfantEventSante size={size} classCSS={classCSS} />;
    case "FIEVRE":
      return <EnfantFievre size={size} classCSS={classCSS} />;
    case "VOMI":
      return <EnfantVomi size={size} classCSS={classCSS} />;
    case "TOUX":
      return <EnfantToux size={size} classCSS={classCSS} />;
    case "BLESSURE":
      return <EnfantBlessure size={size} classCSS={classCSS} />;
    case "BOUTONS":
      return <EnfantBoutons size={size} classCSS={classCSS} />;
    case "PATE_A_MODELER":
      return <EnfantPateModule size={size} classCSS={classCSS} />;
    case "PEINTURE":
      return <EnfantPienture size={size} classCSS={classCSS} />;
    case "DANSE":
      return <EnfantDanse size={size} classCSS={classCSS} />;
    case "SORTIE":
      return <EnfantSortie size={size} classCSS={classCSS} />;
    case "PISCINE":
      return <EnfantPiscine size={size} classCSS={classCSS} />;
    case "LECTURE":
      return <EnfantLecture size={size} classCSS={classCSS} />;
    case "ACTIVITE_MANUELLE":
      return <EnfantActiviteManuelle size={size} classCSS={classCSS} />;
    case "ACTIVITE":
      return <EnfantAutre size={size} classCSS={classCSS} />;
    default:
      return "";
  }
}

//function switch all text
export function textEVENTSwitch(event, t) {
  let typeEvent = event.typeEvent;
  if (t) {
    const map = {
      "ARRIVEE": t('timeline.arrival'),
      "DEPART": t('timeline.departure'),
      "SIESTE": t('timeline.nap'),
      "REPAS_PEU": t('timeline.ate_little'),
      "REPAS_CORRECTEMENT": t('timeline.ate_well'),
      "REPAS_BEAUCOUP": t('timeline.ate_a_lot'),
      "BIBERON": event.quantite + " ml",
      "NEXT_BIBERON": t('timeline.next_bottle'),
      "PETITE_COMMISSION": t('timeline.pee'),
      "GROSSE_COMMISSION": t('timeline.stool'),
      "INCIDENT": t('timeline.incident'),
      "FIEVRE": t('timeline.fever'),
      "VOMI": t('timeline.vomit'),
      "TOUX": t('timeline.cough'),
      "BLESSURE": t('timeline.injury'),
      "BOUTONS": t('timeline.rash'),
      "ACTIVITE": t('timeline.activity'),
      "PATE_A_MODELER": t('timeline.modeling_clay'),
      "PEINTURE": t('timeline.painting'),
      "DANSE": t('timeline.dance'),
      "SORTIE": t('timeline.outing'),
      "PISCINE": t('timeline.pool'),
      "LECTURE": t('timeline.reading'),
      "ACTIVITE_MANUELLE": t('timeline.manual_activities'),
      "AUTRE": t('timeline.other')
    };
    return (map[typeEvent] || "") + " ";
  }
  switch (typeEvent) {
    case "ARRIVEE":
      return "Arrivée ";
    case "DEPART":
      return "Départ ";
    case "SIESTE":
      return "Sieste ";
    case "REPAS_PEU":
      return "Peu mangé ";
    case "REPAS_CORRECTEMENT":
      return "Correctement mangé ";
    case "REPAS_BEAUCOUP":
      return "Beaucoup mangé ";
    case "BIBERON":
      return event.quantite + " ml";
    case "NEXT_BIBERON":
      return "Prochain biberon ";
    case "PETITE_COMMISSION":
      return "Pipi ";
    case "GROSSE_COMMISSION":
      return "Selles ";
    case "INCIDENT":
      return "Incident ";
    case "FIEVRE":
      return "Fiévre ";
    case "VOMI":
      return "Vomi ";
    case "TOUX":
      return "Toux ";
    case "BLESSURE":
      return "Blessure ";
    case "BOUTONS":
      return "Boutons ";
    case "ACTIVITE":
      return "Activité ";
    case "PATE_A_MODELER":
      return "Pâte à modeler ";
    case "PEINTURE":
      return "Pienture ";
    case "DANSE":
      return "Danse ";
    case "SORTIE":
      return "Sortie ";
    case "PISCINE":
      return "Piscine ";
    case "LECTURE":
      return "Lecture ";
    case "ACTIVITE_MANUELLE":
      return "Activités manuelles ";
    case "AUTRE":
      return "Autre ";
    default:
      return "";
  }
}

export function toUpperCaseFirst(string) {
  if (!_.isEmpty(string)) {
    string.toLowerCase();
    return string.charAt(0).toUpperCase() + string.substring(1);
  }
}

export function toLowerCaseFirst(string) {
  if (!_.isEmpty(string)) return string.toLowerCase();
}

export function equalName(alimentA, alimentB) {
  return alimentA === alimentB;
}

export function translateAlimentLibelle(libelle, t) {
  if (!t) return libelle;
  const key = "aliments." + libelle.toLowerCase()
    .replace(/\s+/g, '_')
    .replace(/[éèê]/g, 'e')
    .replace(/[àâ]/g, 'a')
    .replace(/[ùû]/g, 'u')
    .replace(/[ôö]/g, 'o')
    .replace(/[îï]/g, 'i')
    .replace(/[ç]/g, 'c')
    .replace(/-/g, '_');
  const translated = t(key, { defaultValue: '' });
  return translated || libelle;
}

//function aliments libelle
export function matchAfterUrl(string) {
  const regex = /aliments\/(.*)/;
  return string.match(regex)[1];
}
//function aliments libelle
export function toFrenchDays(string) {
  switch (string) {
    case "MONDAY":
      return "Lundi";
    case "TUESDAY":
      return "Mardi";
    case "WEDNESDAY":
      return "Mercredi";
    case "THURSDAY":
      return "Jeudi";
    case "FRIDAY":
      return "Vendredi";
    case "SATURDAY":
      return "Samedi";
    case "SUNDAY":
      return "Dimanche";
    default:
      return "";
  }
}

//Fonction status Participants Events
export function ParticipantsStatus(statutInvitation, t) {
  if (t) {
    switch (statutInvitation) {
      case "ACCEPTEE":
        return t('participants_status.confirmed');
      case "EN_ATTENTE":
        return t('participants_status.pending');
      case "DECLINEE":
        return t('participants_status.declined');
      default:
        return "";
    }
  }
  switch (statutInvitation) {
    case "ACCEPTEE":
      return "Confirmé";
    case "EN_ATTENTE":
      return "En attente";
    case "DECLINEE":
      return "Décliné";
    default:
      return "";
  }
}

//Fonction Staff
export function switchTypeCompte(params) {
  switch (params) {
    case "ADMIN_CRECHE":
      return "Administrateur";
    case "AGENT_CRECHE_CONFIRME":
      return "Utilisateur avancé";
    case "AGENT_CRECHE_NON_CONFIRME":
      return "Utilisateur";
    case "PARENT":
      return "Parent";
    default:
      return "Utilisateur";
  }
}
export function switchEtatCompte(params) {
  switch (params) {
    case "CONFIRMER":
      return "Compte confirmé";
    case "A_CONFIRMER":
      return "Confirmation en attente";
    default:
      return "Confirmation en attente";
  }
}
export function switchFonction(params, sexe) {
  switch (params) {
    case "DIRECTRICE":
      return "Directrice/teur";
    case "PUERCULTIRCE":
      return "Auxiliaire de puériculture";
    case "EDUCATRICE":
      return "Educatrice/teur";
    case "INFERMIERE":
      return "Infirmière";
    case "AUXILIAIRE_PUERICULTURE":
      return "Assistant(e) Petite Enfance";
    case "CUISINERE":
      return "Cuisinier(e)";
    case "ENTRETIEN":
      return "Agent d'entretien";
    case "AUTRE":
      return "Autre";
    default:
      return "Autre";
  }
}

export function formatName(prenom, nom) {
  return toUpperCaseFirst(prenom) + " " + toUpperCaseFirst(nom);
}

export const styles = {
  bounce: {
    animation: "x 0.5s",
    animationName: Radium.keyframes(fadeIn, "fadeInDown"),
    background: "rgba(0, 76, 197, 0.7)",
  },
  bounce2: {
    animation: "x 0.5s",
    animationName: Radium.keyframes(fadeOut, "fadeOutUp"),
    background: "rgba(0, 76, 197, 0.7)",
  },
};
